import { FunctionComponent, ReactNode } from "react";
import AutoplayCarousel from "../../components/atoms/slider/AutoplayCarousel";
import classNames from "classnames";

export interface IGalleryTemplate {
  configsFromLayout: any;
  configs: any;
  children: ReactNode;
  shouldShowProfile?: boolean;
  shouldShowBackground?: boolean;
  parentClassname?: string;
  showOverlay?: boolean;
}

const GalleryTemplate: FunctionComponent<IGalleryTemplate> = ({
  configsFromLayout,
  configs,
  children,
  shouldShowBackground = true,
  parentClassname,
  showOverlay = true,
}) => {
  const fontFamilyStylePrimary = {
    fontFamily: `'${configsFromLayout?.configs?.primary_font?.value}', sans-serif`,
  };
  const fontFamilyStyleSecondary = {
    fontFamily: `'${configsFromLayout?.configs?.secondary_font?.value}', sans-serif`,
  };
  const className = classNames(parentClassname, "w-full h-screen ");

  return (
    <div
      className={className}
      style={{
        background: shouldShowBackground
          ? `${configsFromLayout?.configs?.background_color?.value}`
          : "transparent",
      }}
    >
      <AutoplayCarousel config={{ ...configs }}>{children}</AutoplayCarousel>
      {showOverlay &&
        (configsFromLayout.configs.logo.value ||
          configsFromLayout.configs.title.value ||
          configsFromLayout.configs.description.value) && (
          <div
            className={`absolute bottom-[3.5vh] left-1/2 transform -translate-x-1/2 flex justify-center items-center z-10 bg-white/50 rounded-[8px] p-[1.2vh]`}
          >
            {configsFromLayout.configs.logo.value && (
              <img
                alt={configsFromLayout.configs.logo.value}
                src={configsFromLayout.configs.logo.value}
                className="rounded-[9px] h-[calc(2.2vw_+_2.2vh)] object-contain"
              />
            )}
            <div className="flex flex-col justify-center-center pl-[1.2vh]">
              {configsFromLayout.configs.title.value && (
                <p
                  className="font-medium text-[calc(0.8vw_+_0.8vh)]"
                  style={{
                    color: configsFromLayout?.configs?.text?.value,
                    ...fontFamilyStylePrimary,
                  }}
                >
                  {configsFromLayout.configs.title.value}
                </p>
              )}
              {configsFromLayout.configs.description.value && (
                <p
                  className="font-medium text-[calc(0.7vw_+_0.7vh)] text-main-100 opacity-50"
                  style={{
                    color: configsFromLayout?.configs?.text?.value,
                    ...fontFamilyStyleSecondary,
                  }}
                >
                  {configsFromLayout.configs.description.value}
                </p>
              )}
            </div>
          </div>
        )}
    </div>
  );
};

export default GalleryTemplate;
